import { enhancedRequest,ragStreamRequest } from '../utils/request.js'


// 听写报告详情（流式）
const getReportDetail = (data = {}, token = null) => enhancedRequest({
  url: `/api/v1/ai/dictation/report/${data.reportId}`,
  method: 'get',
  token: token // 传入自定义 token（aiToken）
})

// ai听写-报告内容解析（流式）
const parseReportDetail = (data = {}, onMessage, token = null, onComplete = null) => ragStreamRequest({
  url: `/api/v1/ai/english/word/parsePrompt`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
}, onMessage, onComplete)

// 获取报告提示词
const getReportPrompt = (reportId, token = null) => enhancedRequest({
  url: `/api/v1/ai/dictation/ai/prompt/${reportId}`,
  method: 'get',
  token: token // 传入自定义 token（aiToken）
})

// 报告ai分析报告内容保存
const saveReportPrompt = (data = {}, token = null) => enhancedRequest({
  url: `/api/v1/ai/dictation/ai/analysis/report`,
  method: 'post',
  data,
  token: token // 传入自定义 token（aiToken）
})

export {
    getReportDetail,
    parseReportDetail,
    getReportPrompt,
    saveReportPrompt
}